import { useEffect, useState } from "react";
import { useDragDropManager } from "react-dnd";

interface IUseWebsiteBuilderDndManager {
  isDragging: boolean;
}

export function useWebsiteBuilderDndManager(): IUseWebsiteBuilderDndManager {
  const dragDropManager = useDragDropManager();
  const monitor = dragDropManager.getMonitor();

  const [isDragging, setIsDragging] = useState(monitor.isDragging());

  useEffect(() => {
    const unsubscribe = monitor.subscribeToStateChange(() => {
      setIsDragging(monitor.isDragging());
    });

    return unsubscribe;
  }, [monitor]);

  return { isDragging };
}
